export type EmailProcessingStep =
  | 'processing'
  | 'classifying'
  | 'classified'
  | 'creating_tasks'
  | 'agent_processing'
  | 'completed';

export function getProcessingLabel(step: EmailProcessingStep | undefined): string | undefined {
  switch (step) {
    case 'processing':
      return 'Processing email...';
    case 'classifying':
      return 'Classifying email...';
    case 'classified':
      return 'Analyzed, creating tasks...';
    case 'creating_tasks':
      return 'Creating tasks...';
    case 'agent_processing':
      return 'Agent is sending reply...';
    default:
      return undefined;
  }
}

const NORMALIZE_EMAIL_STATUS: Record<string, EmailProcessingStep> = {
  processing: 'processing',
  classifying: 'classifying',
  classified: 'classified',
  handling_delivery_failure: 'classified',
  handling_payment_promise: 'classified',
  handling_dispute: 'classified',
  handling_wrong_contact: 'classified',
  handling_dunning: 'classified',
  handling_dispute_resolution: 'classified',
  generating_response: 'classified',
  creating_tasks: 'creating_tasks',
  agent_processing: 'agent_processing',
  completed: 'completed',
};

export const normalizeEmailStatus = (status: string): EmailProcessingStep | undefined =>
  NORMALIZE_EMAIL_STATUS[status];

export function resolveEmailThreadProcessingStep(
  thread: { id: string; emails?: { processing_status?: string }[] },
  processingSteps?: Map<string, EmailProcessingStep>,
): EmailProcessingStep | undefined {
  const pusherStep = processingSteps?.get(thread.id);
  if (pusherStep === 'completed') return undefined;
  if (pusherStep) return pusherStep;
  const latestEmail = thread.emails?.[thread.emails.length - 1];
  const modelStep = latestEmail?.processing_status
    ? NORMALIZE_EMAIL_STATUS[latestEmail.processing_status]
    : undefined;
  return modelStep && modelStep !== 'completed' ? modelStep : undefined;
}

export interface EmailProcessingEvent {
  email_id: string;
  message?: string;
  organization_id: string;
  partner_id: string;
  processing_status: string;
  thread_id: string;
}
